import { disablePageScroll, enablePageScroll } from 'scroll-lock';

export default function toggleMobileMenu() {
  let button = $('.header__burger');
  let menu = $('.header__menu');
  let close = $('.header__close');
  button.on('click', function() {
    if ($(this).hasClass('active')) {
      menu.removeClass('active');
      enablePageScroll();
      $(this).removeClass('active');
    } else {
      menu.addClass('active');
      disablePageScroll();
      $(this).addClass('active');
    }
  });
  close.on('click', function() {
    button.removeClass('active');
    menu.removeClass('active');
    enablePageScroll();
  });
  $(window).on('resize', function() {
    if ($(window).width() >= 1280 && button.hasClass('active')) {
      button.removeClass('active');
      menu.removeClass('active');
      enablePageScroll();
    }
  });
}
toggleMobileMenu();